import React from "react";
import { useNavigate } from "react-router-dom";
import "./TaskDashboard.css";
import axios from "axios";
import { Dropdown } from "@fluentui/react/lib/Dropdown";
import { useQuery } from "react-query";
import { useMutation } from "react-query";
import SpinningLoader from "../Loaders/SpinningLoader.js";
import { dateFormat, filterDropdownOptions } from "./Dashboard.utils.js";
import {
  TextField,
  Label,
  DefaultButton,
  DatePicker,
  DayOfWeek,
  mergeStyles,
  defaultDatePickerStrings,
} from "@fluentui/react";
import moment from "moment";

const rootClass = mergeStyles({ width: 200 });
const skillsOptionss = [
  { key: "Java", text: "Java" },
  { key: "Shell Script", text: "Shell Script" },
  { key: "Python Script", text: "Python Script" },
];

const getFilterDropdownOptions = async () => {
  const { data } = await axios.get(
    "https://mgt4g63xtf.execute-api.us-east-2.amazonaws.com/Prod"
  );
  return data;
};
const TaskApiData = async (data) => {
  const { data: response } = await axios.post(
    "https://ik66dbp4jb.execute-api.us-east-2.amazonaws.com/Prod",
    data,
    { headers: { "Content-Type": "application/json" } }
  );

  return response.data;
};
const TaskDashboard = () => {
  const [firstDayOfWeek] = React.useState(DayOfWeek.Sunday);

  const navigate = useNavigate();

  const [stateData, setStateData] = React.useState({
    TaskName: "",
    TaskDescription: "",
    AssignedTo: null,
    TimeAllocated: "",
    TaskDeadLine: null,
    skillsData: [],
  });

  const { data: optionsData } = useQuery(
    "getFilterDropdownOptions",
    getFilterDropdownOptions,
    { staleTime: Infinity }
  );

  const options = React.useMemo(() => {
    return optionsData?.map((d) => {
      return {
        key: d.loginid,
        text: d.loginid,
      };
    });
  }, [optionsData]);

  const { mutate, isLoading } = useMutation(TaskApiData, {
    onSuccess: () => {
      alert("Task Assigned Successfully!");
    },
    onError: (error) => {
      alert(error?.message);
    },
  });

  const inputEvent = () => {
    if (
      stateData.skillsData &&
      stateData.TaskDeadLine &&
      stateData.TaskName !== "" &&
      stateData.TaskDescription !== "" &&
      stateData.AssignedTo !== "" &&
      stateData.TimeAllocated !== ""
    ) {
      const id = new Date().getTime().toString();
      let dataBody = {
        TaskStatus: "Assigned",
        id: id,
        ...stateData,
        TaskDeadLine: moment(stateData.TaskDeadLine).format("DD-MM-yyyy"),
      };

      mutate(dataBody);
    } else {
      alert(`All fields are required !`);
    }
    clearAllFields();
  };

  const dropdownStyles = {
    callout: { maxHeight: 200 },
    dropdown: { width: 200 },
  };

  const handleLogout = React.useCallback(() => {
    localStorage.clear();
    navigate("/login");
  }, [navigate]);

  const clearAllFields = () => {
    setStateData({
      TaskName: "",
      TaskDescription: "",
      skillsData: [],
      AssignedTo: null,
      TimeAllocated: null,
      TaskDeadLine: null,
    });
  };

  return (
    <>
      <SpinningLoader isLoading={isLoading} />
      <div className="main_div">
        <div className="logout-btn">
          <DefaultButton onClick={() => handleLogout()}>Logout</DefaultButton>
        </div>

        <form className="myForm">
          <div className="row">
            <div className="column">
              <div className="input_group">
                <Label>Task Name: </Label>
                <TextField
                  onChange={(e) => {
                    setStateData({ ...stateData, TaskName: e.target.value });
                  }}
                  value={stateData.TaskName}
                  id="customer_name"
                  name="TaskName"
                />
              </div>
              <br />
              <div className="input_group">
                <Label>Task Description: </Label>
                <TextField
                  onChange={(e) => {
                    setStateData({
                      ...stateData,
                      TaskDescription: e.target.value,
                    });
                  }}
                  value={stateData.TaskDescription}
                  name="TaskDescription"
                />
              </div>
              <br />
              <div className="input_group">
                <Label>Skills: </Label>
                <Dropdown
                  className="select_options"
                  multiSelect
                  name="skillsData"
                  selectedKeys={stateData.skillsData}
                  options={skillsOptionss}
                  onChange={(e, option) =>
                    setStateData((state) => {
                      if (option.selected) {
                        return {
                          ...state,
                          skillsData: [...stateData.skillsData, option.text],
                        };
                      } else {
                        return {
                          ...state,
                          skillsData: stateData.skillsData.filter(
                            (item) => item !== option.text
                          ),
                        };
                      }
                    })
                  }
                  styles={dropdownStyles}
                ></Dropdown>
              </div>
              <br />
              <div className="input_group">
                <Label>Assign to: </Label>
                <Dropdown
                  options={options}
                  styles={dropdownStyles}
                  name="AssignedTo"
                  selectedKey={stateData.AssignedTo}
                  onChange={(e, option) => {
                    setStateData({ ...stateData, AssignedTo: option.text });
                  }}
                />
              </div>
              <br />
              <div className="input_group">
                <Label>Hour of Estimation:</Label>
                <Dropdown
                  options={filterDropdownOptions}
                  styles={dropdownStyles}
                  selectedKey={stateData.TimeAllocated}
                  onChange={(e, option) => {
                    setStateData({ ...stateData, TimeAllocated: option.key });
                  }}
                  name="TimeAllocated"
                />
              </div>
              <br />
              <div className="input_group">
                <Label>Dead Line:</Label>
                <div className={rootClass}>
                  <DatePicker
                    firstDayOfWeek={firstDayOfWeek}
                    placeholder="Select  a  date ..."
                    ariaLabel="Select  a  date"
                    name="TaskDeadLine"
                    formatDate={(date) => dateFormat(date, "dd-mm-yyyy")}
                    strings={defaultDatePickerStrings}
                    value={stateData.TaskDeadLine}
                    onSelectDate={(e) => {
                      setStateData({
                        ...stateData,
                        TaskDeadLine: e,
                      });
                    }}
                  />
                </div>
                <br />
              </div>
            </div>
            <div className="btns">
              <DefaultButton onClick={() => inputEvent()}>Save</DefaultButton>
              <DefaultButton onClick={() => clearAllFields()}>
                Clear
              </DefaultButton>
              <DefaultButton onClick={() => navigate("/task-report")}>
                Next
              </DefaultButton>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default TaskDashboard;
